import { Building2, Trees, Sprout, MapPinned, Car } from "lucide-react";

export const CATEGORIES = [
  { value: "daire", label: "Daire", icon: Building2, description: "Prestijli daireler ve rezidanslar" },
  { value: "arsa", label: "Arsa", icon: MapPinned, description: "Yatırımlık ve imarlı arsa fırsatları" },
  { value: "tarla", label: "Tarla", icon: Sprout, description: "Verimli tarım ve yatırım arazileri" },
  { value: "bahce", label: "Bahçe", icon: Trees, description: "Doğayla iç içe bahçe ve villa arsaları" },
  { value: "vasita", label: "Vasıta", icon: Car, description: "Satılık ve kiralık araçlar" },
];

export const getCategoryMeta = (value) => CATEGORIES.find((c) => c.value === value);

export const LISTING_TYPES = [
  { value: "satilik", label: "Satılık" },
  { value: "kiralik", label: "Kiralık" },
];

// Faz 4: Kiralık seçilebilen kategoriler - Daire hep destekliyordu, Vasıta (araç
// kiralama) Faz 4 ile eklendi. Arsa/Tarla/Bahçe kasıtlı olarak dahil edilmedi -
// mevcut davranışları (sadece Satılık) korunuyor. Backend'deki
// RENTAL_ENABLED_CATEGORIES ile birebir aynı liste.
export const RENTAL_ENABLED_CATEGORIES = ["daire", "vasita"];

export const MAP_MODE_LABELS = {
  standard: "Standart Konum",
  blurred: "Gizli Konum",
  nearby: "Yakın Konum",
};

export const MAP_MODE_OPTIONS = [
  { value: "standard", label: "Standart / Tam Konum" },
  { value: "blurred", label: "Gizli (Blurlu) Konum" },
  { value: "nearby", label: "Yakın Konum İşaretleme" },
];

// Faz 4 (final UX): "Bütçeniz" gerçek bir parasal miktar olduğundan Fiyat/KM ile
// birebir aynı davranışı alır - harf girilemez, yazarken Türkçe binlik ayraçla
// gösterilir ("5000000" -> "5.000.000"), state'te/API'ye giden payload'da ise
// her zaman düz, noktasız bir rakam dizisi kalır (bkz. DynamicFieldsStep.js,
// NumericInput). "Büyüklük" (m²/Dönüm) de gerçek bir sayısal miktar olduğundan
// harf kabul etmez, ancak Fiyat/KM değil bu yüzden binlik ayraç UYGULANMAZ.
export const DYNAMIC_INQUIRY_FIELDS = {
  daire: [
    { name: "oda_sayisi", label: "Aradığınız Oda Sayısı", type: "select", options: ["1+0", "2+0", "1+1", "2+1", "3+1", "4+1", "5+1 ve üzeri"] },
    { name: "islem_turu", label: "İşlem Türü", type: "select", options: ["Satılık", "Kiralık"] },
    { name: "butce", label: "Bütçeniz (TL)", type: "number", thousands: true, placeholder: "Örn: 5.000.000" },
  ],
  arsa: [
    { name: "buyukluk", label: "Aradığınız Büyüklük (m²)", type: "number", placeholder: "Örn: 1000" },
    { name: "imar_durumu", label: "İmar Durumu Tercihi", type: "select", options: ["İmarlı", "İmarsız", "Farketmez"] },
    { name: "butce", label: "Bütçeniz (TL)", type: "number", thousands: true, placeholder: "Örn: 2.000.000" },
  ],
  tarla: [
    { name: "buyukluk", label: "Aradığınız Büyüklük (m²/Dönüm)", type: "number", placeholder: "Örn: 5000" },
    { name: "sulama", label: "Sulama İmkanı", type: "select", options: ["Olmalı", "Farketmez"] },
    { name: "butce", label: "Bütçeniz (TL)", type: "number", thousands: true, placeholder: "Örn: 1.500.000" },
  ],
  bahce: [
    { name: "buyukluk", label: "Aradığınız Büyüklük (m²)", type: "number", placeholder: "Örn: 2000" },
    { name: "meyve_bahcesi", label: "Meyve Bahçesi Olsun mu?", type: "select", options: ["Evet", "Hayır", "Farketmez"] },
    { name: "butce", label: "Bütçeniz (TL)", type: "number", thousands: true, placeholder: "Örn: 500.000" },
  ],
  vasita: [
    { name: "arac_tipi", label: "Aradığınız Araç Tipi", type: "text", placeholder: "Örn: Binek Otomobil, SUV" },
    { name: "islem_turu", label: "İşlem Türü", type: "select", options: ["Satılık", "Kiralık"] },
    { name: "butce", label: "Bütçeniz (TL)", type: "number", thousands: true, placeholder: "Örn: 500.000" },
  ],
};

export const formatPrice = (price, currency = "TRY") => {
  if (price === null || price === undefined) return "";
  const symbol = currency === "TRY" ? "₺" : currency;
  return `${symbol}${Number(price).toLocaleString("tr-TR")}`;
};

// İlan galerisi için üst sınır.
export const MAX_LISTING_IMAGES = 50;
